export const EducationList: Array<EducationType> = [
  {
    title: 'IB (International Baccalaureate) programme graduate',
    date: '2020-2022',
  },
  {
    title:
      'Self taugth programmer - Completed over than 250 online courses (on: JavaScript / TypeScript / React / React Native / Node JS / Swift / Swift UI / UIKit / C++ / Java / Haskell)',
    date: '2020-2021',
    isCode: true,
  },
]

export interface EducationType {
  title: string
  date: string
  isCode?: boolean
}
